import { ApolloQueryResult } from '@apollo/client';

import {
  AvFileProcess,
  FileProcess,
  GenericFileProcess,
  GetFileQuery,
  GetFileQueryVariables,
  PiiFileProcess,
} from '../../graphql/generated';

export type RefetchFileDetails = (
  variables?: Partial<GetFileQueryVariables>
) => Promise<ApolloQueryResult<GetFileQuery>>;

export const isGenericFileProcess = (
  fileProcess: FileProcess
): fileProcess is GenericFileProcess => {
  return fileProcess.__typename === 'GenericFileProcess';
};

export const isPiiFileProcess = (
  fileProcess: FileProcess
): fileProcess is PiiFileProcess => {
  return fileProcess.__typename === 'PIIFileProcess';
};

export const isAvFileProcess = (
  fileProcess: FileProcess
): fileProcess is AvFileProcess => {
  return fileProcess.__typename === 'AVFileProcess';
};
